import { render, staticRenderFns } from "./CajaComponent.vue?vue&type=template&id=4f1f006a&scoped=true"
import script from "./CajaComponent.vue?vue&type=script&lang=js"
export * from "./CajaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1f006a",
  null
  
)

export default component.exports